module.exports = __webpack_public_path__ + "img/tablet-neck-12_18x572.04705e9a.png";